// @flow
import React, { type Node } from 'react';
import './SavesTemplate.scss';

type Props = {
  children: Node,
};

const SavesTemplate = ({ children }: Props) => (
  <div className="SavesTemplate">
    <div className="main">
      <h2>임시 컨텐츠 목록</h2>
      {children}
    </div>
  </div>
);

export default SavesTemplate;



// WEBPACK FOOTER //
// ./src/components/saves/SavesTemplate/SavesTemplate.js